import tw, { css, styled } from 'twin.macro';

export type PageFooterVariant = 'default' | 'viewport';

type StyledPageFooterProps = { $variant: PageFooterVariant };

export const StyledPageFooter = styled.footer<StyledPageFooterProps>`
	${tw`p-4 sm:p-6 max-w-[1200px] mx-auto`}

	${({ $variant }) =>
		$variant === 'viewport' &&
		css`
			${tw`text-gray-200 mb-0 text-center text-sm`}
		`}
`;
